<template>
  <Page subpage>
    <template #header>
      <div class="mb-3">
        <h3>
          No Accounting Classes Available (<a
            :href="qboAccountingClassesLearnMoreLink"
            target="_blank"
            class="link"
            >Learn More</a
          >)
        </h3>
      </div>
    </template>
    <template #body>
      <div>
        <p>
          Your company does not choose to track classes within QuickBooks
          Online, so there are no accounting classes to display. If you'd like
          to begin tracking accounting classes, please enable classes tracking
          in your QuickBooks Online settings and try again.
        </p>
      </div>
    </template>
  </Page>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { getProperty } from "@/lib/helpers";

import Page from "@/components/Page.vue";

const store = useStore();

const qboAccountingClassesLearnMoreLink = computed(() => {
  const link = getProperty(
    store.state.tenantCustomizations,
    "System.qbo_accounting_classes_learn_more_link"
  );
  return link?.value || link?.default;
});
</script>
